"use client";

import { cn } from "@/shared/lib/utils/cn";
import type { ChatRowStatus } from "@/features/chat/multi/signals/chat-signals";

const LABEL: Record<Exclude<ChatRowStatus, "idle">, string> = {
  building: "Building workflow",
  working: "Agent is working",
  needs_input: "Needs your input",
};

/** Single sidebar badge for building / working / HITL — mutually exclusive. */
export function ChatRowStatusDot({
  status,
  className,
}: {
  status: ChatRowStatus;
  className?: string;
}) {
  if (status === "idle") return null;
  const pulse = status === "building" || status === "working";
  return (
    <span
      className={cn(
        "size-2 shrink-0 rounded-full",
        pulse && "animate-pulse bg-primary",
        status === "needs_input" && "bg-amber-500",
        className,
      )}
      aria-label={LABEL[status]}
    />
  );
}

export function chatRowStatusCaption(status: ChatRowStatus, idleLabel: string): string {
  if (status === "building") return "Building…";
  if (status === "working") return "Working…";
  if (status === "needs_input") return "Needs input";
  return idleLabel;
}
